export const getRelevantDate = (maturityDate, asOfDate) => {
  if (!maturityDate && !asOfDate) return '';

  console.log('maturity date ===>', maturityDate);
  console.log('asof date ===>', asOfDate);

  const today = new Date();

  // If maturity date exists and is in the future, use asOfDate
  if (maturityDate && new Date(maturityDate) > today) {
    return asOfDate || '';
  }

  // Otherwise use the earlier of the two dates if both exist
  if (maturityDate && asOfDate) {
    return new Date(maturityDate) < new Date(asOfDate) ? maturityDate : asOfDate;
  }

  // If only one exists, return it
  return maturityDate || asOfDate || '';
};
